import { render } from "./CardAddGoal.vue?vue&type=template&id=4153055f"
import script from "./CardAddGoal.vue?vue&type=script&lang=js"
export * from "./CardAddGoal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__